export const activeProducts = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  viewApplicationDetails: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: view application details'
  }),

  alsoLike: (selectedName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: also like: ${selectedName}`
  }),

  quotationViewNow: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: quotation view now'
  }),

  ctaClick: (ctaLabel, productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: active products: ${productName}: ${ctaLabel}`
  }),

  ctaWithdrawalJourney: (ctaLabel, productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: active products: ${productName}: withdrawal journey: ${ctaLabel}`
  }),

  ctaCallbackRequest: (ctaLabel, productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: active products: ${productName}: callback request: ${ctaLabel}`
  }),

  ctaReApplyJourney: (ctaLabel, productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: active products: ${productName}: re-apply journey: ${ctaLabel}`
  }),

  ctaNewApplication: (ctaLabel, productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: active products',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: active products: ${productName}: new application: ${ctaLabel}`
  })
};
